<emm-management-layout>
    <emm-nutrition-assignments-search layout-center-header class="nutrition-assignments-search">
    </emm-nutrition-assignments-search>
    <emm-nutrition-assignments-location-sets
        *ngIf="locationSetType$ | async"
        layout-center-content
    ></emm-nutrition-assignments-location-sets>
    <emm-nutrition-assignments-list
        *ngIf="!(locationSetType$ | async)"
        layout-center-content
        class="nutrition-assignments-list"
    ></emm-nutrition-assignments-list>
    <emm-nutrition-assignments-right-header
        *ngIf="assignment$ | async"
        layout-right-header
        class="nutrition-assignments-right-header"
    ></emm-nutrition-assignments-right-header>
    <emm-nutrition-assignments-form
        *ngIf="assignment$ | async"
        layout-right-content
        (formStateChanged)="buttonsState = $event"
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        [locationSet]="locationSet$ | async"
    ></emm-nutrition-assignments-form>
    <emm-nutrition-assignments-right-footer
        *ngIf="assignment$ | async"
        [disabledCancelButton]="buttonsState.disableCancel"
        [disabledSaveButton]="buttonsState.disableSave"
        [showPublish]="showPublish$ | async"
        layout-right-footer
        (cancel)="handleCancel()"
        (submit)="handleSubmit()"
        (publish)="handlePublish()"
        class="emm-nutrition-assignments-right-footer"
    ></emm-nutrition-assignments-right-footer>
</emm-management-layout>
